
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form10";
const form10State = namespace("Form10");

import Form10ProcessHeader from "@/components/process/Form10/components/Form10ProcessHeader.vue";
import Form10 from "@/components/process/Form10/components/pdf/Form10.vue"

import { form10StatusInfoType } from '@/types/Information/Form10';

@Component({
    components:{
        Form10ProcessHeader,
        Form10
    }
})
export default class PreviewForm10 extends Vue {

    @form10State.State
    public currentOrderSingleJusticeId: string;

    stepsCompleted = {} as form10StatusInfoType;
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form10" }); 
    }
}
